export default __webpack_public_path__ + "static/media/PowerPlug.0ff5d75c.svg";